export function themedAssetUrl(fileName: string): string {
  return `${process.env.REACT_APP_ASSETS_URL}/files/${fileName}`;
}
